import { Button, DataTable } from 'shared/components/ui';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../core/context/AuthContext';
import { turnosService } from '../../turnos/services/turnosService';
import { dashboardService } from '../../facturacion/services/dashboardService';
import './DashboardTecnico.css';

const DashboardTecnico = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [turnos, setTurnos] = useState([]);
  const [facturaciones, setFacturaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setLoading(true);
        setError(null);
        const username = user?.username || user?.name || user?.Usuario || '';
        
        if (!username) {
          setError('No se pudo obtener el usuario');
          setLoading(false);
          return;
        }

        const [turnosData, facturacionesData] = await Promise.all([
          turnosService.getProximosTurnos(username),
          dashboardService.getUltimasFacturaciones(username)
        ]);
        setTurnos(turnosData || []);
        setFacturaciones(facturacionesData || []);
      } catch (err) {
        console.error('Error completo:', err);
        setError('Error al cargar los datos del dashboard');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      cargarDatos();
    }
  }, [user]);

  if (loading) {
    return (
      <Container className="mt-4">
        <Alert variant="info">Cargando información...</Alert>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="dashboard-tecnico mt-4">
      <Row>
        <Col xs={12}>
          <Card className="info-card">
            <Card.Header className="card-header-custom">
              <h4><b>Turnos</b></h4>
            </Card.Header>
            <Card.Body>
              <div className="table-container">
                <DataTable className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Paciente</th>
                      <th>Edad</th>
                      <th>Estudio</th>
                      <th>Fecha</th>
                      <th>Horario</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {turnos.length > 0 ? (
                      turnos.map((turno) => (
                        <tr key={turno.idTurno}>
                          <td>{turno.idTurno}</td>
                          <td>{turno.apeNombre}</td>
                          <td>{turno.edad}</td>
                          <td>{turno.tipoEstudio}</td>
                          <td>{turno.fechaIni}</td>
                          <td>{turno.horaIni}</td>
                          <td>{turno.estadoTurno}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="empty-state">
                          No hay turnos cargados próximamente
                        </td>
                      </tr>
                    )}
                  </tbody>
                </DataTable>
              </div>
              <Button variant="warning" onClick={() => navigate('/grilla-turnos')}>
                Ir a Turnos
              </Button>
            </Card.Body>
          </Card>

          <Card className="info-card">
            <Card.Header className="card-header-custom">
              <h4><b>LIQUIDACIONES</b></h4>
            </Card.Header>
            <Card.Body>
              <div className="table-container">
                <DataTable className="data-table">
                  <thead>
                    <tr>
                      <th>Año</th>
                      <th>Mes</th>
                      <th>Cantidad</th>
                      <th>Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {facturaciones.length > 0 ? (
                      facturaciones.map((fact, index) => (
                        <tr key={index}>
                          <td>{fact.anio}</td>
                          <td>{fact.mes}</td>
                          <td>{fact.cantidad}</td>
                          <td>${fact.importe.toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="empty-state">
                          No hay consultas realizadas para este mes.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </DataTable>
              </div>
              <Button variant="warning" onClick={() => navigate('/facturacion-tecnicos')}>
                Ir a Liquidacion
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardTecnico;
